import { useParams } from 'react-router';
import { Spinner } from '../../../components/Spinner';
import { useAuth } from '../../../hooks/useAuth';
import { useEnv } from '../../../context/env-context';
// tabs
import Rules from './tabs/Rules/Rules';
import Permissions from './tabs/Permissions/Permissions';
import GlobalSettings from './tabs/GlobalSettings/GlobalSettings';
import BankingHolidays from './tabs/BankingHolidays/BankingHolidays';
import ReferralCampaigns from './tabs/ReferralCampaigns/ReferralCampaigns';
import PopupMessages from './tabs/PopupMessages/PopupMessages';
import Rewards from './tabs/Rewards/Rewards';

function SettingsTabController({ settingsSidebar, tabSpinner, setTabSpinner }) {
  const params = useParams();

  let permissions;

  const { user } = useAuth();
  const { audience } = useEnv();

  if (user) {
    permissions = user[`${audience}/metadata`].permissions || [];
  } else {
    permissions = [];
  }

  const getRouteName = (obj, route) =>
    Object.entries(obj).reduce((acc, [key, value]) => {
      if (acc) return acc;
      if (key === route && value.name) return value.name;
      if (typeof value === 'object' && value !== null) {
        return getRouteName(value.nested || value, route);
      }

      return acc;
    }, null);

  return (
    <div className="d-flex flex-column flex-fill overflow-auto">
      <Spinner visible={tabSpinner} wrapperStyle={{ height: '100%', paddingBottom: 48 }}>
        <div className="my-4 mx-2">
          <h5 className="ps-1">{getRouteName(settingsSidebar, params?.tab)}</h5>
        </div>
        {params?.tab === 'rules' && permissions.includes('Rules Management') && (
          <Rules setTabSpinner={setTabSpinner} />
        )}
        {params?.tab === 'referral-campaigns' && permissions.includes('Settings') && (
          <ReferralCampaigns setTabSpinner={setTabSpinner} />
        )}
        {params?.tab === 'popup-messages' && permissions.includes('Settings') && (
          <PopupMessages setTabSpinner={setTabSpinner} />
        )}
        {params?.tab === 'rewards' && permissions.includes('Settings') && (
          <Rewards setTabSpinner={setTabSpinner} />
        )}
        {params?.tab === 'banking-holidays' && permissions.includes('Settings') && (
          <BankingHolidays setTabSpinner={setTabSpinner} />
        )}
        {params?.tab === 'global-settings' && permissions.includes('Settings') && (
          <GlobalSettings setTabSpinner={setTabSpinner} />
        )}
        {params?.tab === 'permissions' && permissions.includes('Admin') && (
          <Permissions setTabSpinner={setTabSpinner} />
        )}
      </Spinner>
    </div>
  );
}

export default SettingsTabController;
